<template>
  <div class="min-h-screen h-full overflow-hidden" style="height:145px">
    <div class="home h-full">
      <div class="flex items-center h-full">
        <div class="w-full md:w-[200px] md:float-left text-center mb-0 md:mb-0">
          <h4 class="mt-1.5 md:mt-0 text-2xl font-semibold text-gray-800">Excellent</h4>
          <div class="mt-2">
            <form>
              <div class="rating">
                <input
                  class="star star-5"
                  id="star-5"
                  type="radio"
                  name="overallRating"
                  value="5"
                  :checked="profileRating == 5"
                  disabled
                />
                <label class="star star-5" for="star-5"></label>
                <input
                  class="star star-4"
                  id="star-4"
                  type="radio"
                  name="overallRating"
                  value="4"
                  :checked="profileRating == 4"
                  disabled
                />
                <label class="star star-4" for="star-4"></label>
                <input
                  class="star star-3"
                  id="star-3"
                  type="radio"
                  name="overallRating"
                  value="3"
                  :checked="profileRating == 3"
                  disabled
                />
                <label class="star star-3" for="star-3"></label>
                <input
                  class="star star-2"
                  id="star-2"
                  type="radio"
                  name="overallRating"
                  value="2"
                  :checked="profileRating == 2"
                  disabled
                />
                <label class="star star-2" for="star-2"></label>
                <input
                  class="star star-1"
                  id="star-1"
                  type="radio"
                  name="overallRating"
                  value="1"
                  :checked="profileRating == 1"
                  disabled
                />
                <label class="star star-1" for="star-1"></label>
              </div>
            </form>
          </div>
          <div class="text-sm py-2">
            <a
              v-bind:href="'https://reviewdrop.io/review/' + author"
              target="_blank"
              class="text-black opacity-70"
            >
              Based on <span class="underline">{{ totalReviews }} reviews</span>
            </a>
          </div>
          <div>
            <a
              v-bind:href="'https://reviewdrop.io'"
              class="block"
              target="_blank"
            >
              <img
                class="w-28 mx-auto"
                src="https://reviewdrop.io/storage/site/email/reviewdrop-email-blk.png"
                alt="Reviewdrop Logo"
              />
            </a>
          </div>
        </div>
        <!-- end of rating col -->
        <div class="hidden md:block rd-carousel--wrapper md:pl-16 w-full relative">
          <VueSlickCarousel
            v-bind="settings"
            v-if="!isLoading && posts.length"
            :arrows="true"
            :dots="false"
            :slidesToShow="3"
            :slidesToScroll="3"
          >
            <div
              class="slide outline-none"
              v-for="post in posts"
              :key="post.id"
            >
              <div class="mx-2 sm:mx-6">
                <div
                  class="flex items-center mt-2 mb-2 text-gray-800 text-base"
                >
                  <div class="order-2 opacity-70 text-sm">
                    {{ post.published }}
                  </div>
                  <form class="order-1 mr-auto relative top-[0.2rem]">
                    <div class="rating">
                      <input
                        class="star star-5"
                        id="star-5"
                        type="radio"
                        :name="post.id"
                        value="5"
                        :checked="post.rating == 5"
                        disabled
                      />
                      <label class="star star-5" for="star-5"></label>
                      <input
                        class="star star-4"
                        id="star-4"
                        type="radio"
                        :name="post.id"
                        value="4"
                        :checked="post.rating == 4"
                        disabled
                      />
                      <label class="star star-4" for="star-4"></label>
                      <input
                        class="star star-3"
                        id="star-3"
                        type="radio"
                        :name="post.id"
                        value="3"
                        :checked="post.rating == 3"
                        disabled
                      />
                      <label class="star star-3" for="star-3"></label>
                      <input
                        class="star star-2"
                        id="star-2"
                        type="radio"
                        :name="post.id"
                        value="2"
                        :checked="post.rating == 2"
                        disabled
                      />
                      <label class="star star-2" for="star-2"></label>
                      <input
                        class="star star-1"
                        id="star-1"
                        type="radio"
                        :name="post.id"
                        value="1"
                        :checked="post.rating == 1"
                        disabled
                      />
                      <label class="star star-1" for="star-1"></label>
                    </div>
                  </form>
                </div>

                <a
                  :href="'https://reviewdrop.io/reviews/' + post.id"
                  target="_blank"
                  class="review-site-link outline-none"
                >
                  <h4
                    v-if="post.title"
                    class="hidden xl:block text-sm xl:text-base font-bold text-gray-800 clamp-text-heading"
                  >
                    {{ post.title | truncate(40, "") }}
                  </h4>
                  <h4
                    v-if="post.title"
                    class="block xl:hidden text-sm xl:text-base font-bold text-gray-800 clamp-text-mob-heading"
                  >
                    {{ post.title | truncate(40, "") }}
                  </h4>
                </a>

                <div class="mt-2">
                  <p class="hidden xl:block text-gray-800 text-sm opacity-60 clamp-text">
                    {{ post.content | truncate(100, "") }}
                  </p>
                  <p class="block xl:hidden text-gray-800 text-sm opacity-60 clamp-text-mob">
                    {{ post.content | truncate(100, "") }}
                  </p>
                </div>
                <div class="flex items-center mt-3">
                <div
                  v-if="post.name"
                  class="
                    flex
                    items-center
                    text-gray-800 text-xs
                    opacity-50
                    
                    
                  "
                >
                  <span>{{ post.name }}</span>
                </div>

                <div v-if="post.order" class="flex items-center opacity-80 ml-auto text-xs text-blue-500"
             content="Review invitation sent after order." v-tippy="{ arrow : true,  animation : 'fade'}">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="h-4 w-4 mr-1"
                fill="currentColor">
                <path
                    d="M4.035 15.479A3.976 3.976 0 0 0 4 16c0 2.378 2.138 4.284 4.521 3.964C9.214 21.198 10.534 22 12 22s2.786-.802 3.479-2.036C17.857 20.284 20 18.378 20 16c0-.173-.012-.347-.035-.521C21.198 14.786 22 13.465 22 12s-.802-2.786-2.035-3.479C19.988 8.347 20 8.173 20 8c0-2.378-2.143-4.288-4.521-3.964C14.786 2.802 13.466 2 12 2s-2.786.802-3.479 2.036C6.138 3.712 4 5.622 4 8c0 .173.012.347.035.521C2.802 9.214 2 10.535 2 12s.802 2.786 2.035 3.479zm1.442-5.403 1.102-.293-.434-1.053A1.932 1.932 0 0 1 6 8c0-1.103.897-2 2-2 .247 0 .499.05.73.145l1.054.434.293-1.102a1.99 1.99 0 0 1 3.846 0l.293 1.102 1.054-.434C15.501 6.05 15.753 6 16 6c1.103 0 2 .897 2 2 0 .247-.05.5-.145.73l-.434 1.053 1.102.293a1.993 1.993 0 0 1 0 3.848l-1.102.293.434 1.053c.095.23.145.483.145.73 0 1.103-.897 2-2 2-.247 0-.499-.05-.73-.145l-1.054-.434-.293 1.102a1.99 1.99 0 0 1-3.846 0l-.293-1.102-1.054.434A1.935 1.935 0 0 1 8 18c-1.103 0-2-.897-2-2 0-.247.05-.5.145-.73l.434-1.053-1.102-.293a1.993 1.993 0 0 1 0-3.848z">
                </path>
                <path d="m15.742 10.71-1.408-1.42-3.331 3.299-1.296-1.296-1.414 1.414 2.704 2.704z"></path>
            </svg> Verified Review
        </div>
        </div>
              </div>
            </div>
          </VueSlickCarousel>

          <loading
            :active.sync="isLoading"
            :can-cancel="false"
            :is-full-page="true"
            :opacity="1"
          ></loading>
        </div>
      </div>

      <!-- end of post grid -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
// import $ from "jquery-slim";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "Home",
  components: {
    Loading,
    VueSlickCarousel,
  },
  data() {
    return {
      isLoading: false,
      page: 0,
      fullPage: true,
      posts: [],
      show: true,
      totalPages: "",
      backgroundColor: "#2e69da",
      borderColor: "",
      currentAuthor: "",
      name: "",
      author: "",
      apiURL: "https://reviewdrop.io/api/reviews/",
      apiUsr: "https://reviewdrop.io/api/user/",
      totalReviews: 0,
      profileRating: 1,
      settings: {
        dots: false,
        infinite: true,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
            },
          },
        ],
      },
    };
  },
  mounted() {
    let q = this.$router.currentRoute.query;
    this.backgroundColor = q.backgroundColor;
    this.borderColor = q.borderColor;
    this.currentAuthor = q.currentAuthor;

    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        // this.headerSize();
                  let message = {
            height: document.body.scrollHeight,
            width: document.body.scrollWidth,
          };

          // window.top refers to parent window
          window.top.postMessage(message, "*");
      }
    };

    this.getPosts();
    this.getAuthor();
  },
  methods: {
    getPosts: function () {
      var self = this;
      self.page++;
      this.isLoading = true;
      axios
        .get(self.apiURL + self.currentAuthor + "?page=" + self.page)
        .then(function (response) {
          let reviewHeader = response.headers["x-review-total"];
          // console.log(reviewHeader);
          self.totalPages = reviewHeader;
          if (self.page >= self.totalPages) {
            self.show = false;
          }
          var datas = response.data;

          datas.forEach(function (element) {
            self.posts.push(element);
          });
          self.isLoading = false;

          // let message = {
          //   height: document.body.scrollHeight,
          //   width: document.body.scrollWidth,
          // };

          // // window.top refers to parent window
          // window.top.postMessage(message, "*");
        });
    },
    getAuthor: function () {
      let self = this;
      axios.get(self.apiUsr + self.currentAuthor).then(function (response) {
        var author = response.data;
        self.author = author.id;
        self.name = author.name;
        self.totalReviews = author.review_count;
        self.profileRating = author.rating;
        // console.log(author);
      });
    },
    // headerSize: function () {
    //   var rgb = $(".author-meta").css("backgroundColor");
    //   var pattern = /rgb\((\d+),\s?(\d+),\s?(\d+)\)/;
    //   var matches = rgb.match(pattern);
    //   var o = Math.round(
    //     (parseInt(matches[1]) * 299 +
    //       parseInt(matches[2]) * 587 +
    //       parseInt(matches[3]) * 114) /
    //       1000
    //   );
    //   if (o > 125) {
    //     // eslint-disable-next-line
    //     var ir = "0";
    //     // eslint-disable-next-line
    //     var ig = "0";
    //     // eslint-disable-next-line
    //     var ib = "0";
    //     // eslint-disable-next-line
    //     var authorBtnBG = "51,51,51,0.35";
    //     var filterOpac = "51,51,51,0.7";
    //   } else {
    //     // eslint-disable-next-line
    //     var ir = "255";
    //     // eslint-disable-next-line
    //     var ig = "255";
    //     // eslint-disable-next-line
    //     var ib = "255";
    //     // eslint-disable-next-line
    //     var authorBtnBG = "255,255,255,0.35";
    //     // var authorBtnOpac = '0.7';
    //     filterOpac = "255,255,255,0.7";
    //   }
    //   $(".author-meta span,.author-meta h2").css(
    //     "color",
    //     "rgb(" + ir + "," + ig + "," + ib + ")"
    //   );
    //   $(".review-filter").css("color", "rgba(" + filterOpac + ")");
    //   $(".author-submit .btn-primary").css(
    //     "background-color",
    //     "rgba(" + authorBtnBG + ")"
    //   );
    // },
  },
};
</script>
